<app-dropdown-control
  [data]="options$ | async"
  [selectFirstValue]="false"
  [ngModel]="selectedOption$ | async"
  [displayValueSelector]="selectDisplayValue"
  (ngModelChange)="changeSortOption($event)"
>
</app-dropdown-control>